module.exports = "https://bin.bnbstatic.com/_next/static/images/blakejeong727-bf100e7f9cc4cbaf6654edb3a00a6d95.jpg";